import React, { useEffect, useState } from "react";
import { Carousel } from "react-bootstrap";
import { motion } from "framer-motion";
import "bootstrap/dist/css/bootstrap.min.css";
import Image1 from "./images/informes.jpg";
import Image2 from "./images/capacitacion.jpg";
import Image3 from "./images/image3.jpg";
import { Link } from "react-router-dom";
import logrust from "../../assets/images/Rocky/rustdesk-logo.png";
import logBullzip from "../../assets/images/Rocky/bullzip.jpg";
import logoApp from "../../assets/images/Rocky/LOGOROCKY.png";
import { MessageToastify } from "../../utils/funtions/MessageToastify";
import { ToastContainer } from "react-toastify";
import ClientesCarousel from "./Sides";
import ApiBack from "../../utils/domains/ApiBack";
import News from "../../models/News";
import axios from "axios";
import PublicNavar from "../../componet/PublicNavar";
import WhatsAppButton from "../../componet/WhatsAppButton";
import { Footer } from "./component/Footer";
import "../public/styles/index.css";
import { Navbar } from "./component/Navar";
// import Snowfall from 'react-snowfall'

export const Index = () => {
  const [loading, setLoading] = useState(false);
  const [arrayAllNews, setArrayAllNews] = useState<News[]>([]);


  const getAllNews = async () => {
    setLoading(true);
    try {
      const url = `${ApiBack.URL}${ApiBack.LAST_NEWS}`;

      try {
        const response = await axios.get(url);
        const data = response.data;
        if (!data || data.length === 0) {
          MessageToastify(
            "info",
            "No se encontraron resultados para los filtros seleccionados.",
            4000
          );
          setArrayAllNews([]);
          return;
        }
        if (data && Array.isArray(data)) {
          setArrayAllNews(data);
          setLoading(false);
          console.log(data);

        } else {
          console.error("La respuesta no es un array:", data);
          MessageToastify("info", data.error, 4000);
          setArrayAllNews([]);
        }
      } catch (error) {
        console.error("Error al obtener los datos:", error);
        MessageToastify("info", "No se encuentran resultados.", 2000);
        setArrayAllNews([]);
        setLoading(true);
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
    } finally {
      setLoading(false);
    }
  };
  const truncateText = (text: string, maxLength: any) =>
    text?.length > maxLength ? `${text.substring(0, maxLength)}...` : text;

  useEffect(() => {
    getAllNews()
    //   MessageToastify(
    //   "info",
    //   "Recuerde que el doctor cumple el 5 de Septiembre.",
    //   2000
    // );
    //   MessageToastify(
    //   "error",
    //   "No se les vaya a olvidar.",
    //   4000
    // );
  }, []);
  return (
    <>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" />
      <link
        href="https://fonts.googleapis.com/css2?family=Aclonica&family=Crimson+Text:ital,wght@0,400;0,600;0,700;1,400;1,600;1,700&family=DynaPuff:wght@400..700&family=Noto+Serif+Telugu:wght@100..900&family=Righteous&family=Rozha+One&display=swap"
        rel="stylesheet"
      />
      {/* <Snowfall color="white" snowflakeCount={200} />
        <Snowfall
          snowflakeCount={200}
          color="#ff0000"   // rojo
        />
        <Snowfall
          snowflakeCount={200}
          color="#00ff00"   // verde
        /> */}
      <Navbar />

      {/* "Inicio" Section */}
      {/* <motion.div
        id="inicio"
        className="inicio-section"
        initial={{ opacity: 0, x: -100 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h2>Bienvenido a Rocky</h2>
        <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit...</p>
      </motion.div> */}

      {/* "Servicios" Section */}
      <motion.div
        id="servicios"
        className="servicios-section p-6 rounded-xl"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.1 }}
        transition={{ duration: 1, ease: "easeOut" }}
        style={{ opacity: 1 }}
      >
        <h2
          style={{
            fontFamily: "Righteous, sans-serif",
            fontSize: "5em",
            background: "( #003366)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            color: "transparent",
          }}
        >
          Servicios
        </h2>

        <div className="servicios-grid">
          <div
            className="servicio-item"
            style={{ backgroundColor: "#003366", color: "#ffffff" }}
          >
            <h3 style={{ color: "#dabf5c" }}>Diseño del software</h3>
            <p>
              Software es construido con un modelo evolutivo y abierto, el cual
              nos permite entregar resultados en tiempos óptimos y ajustados a
              la normativas vigente, el software sistema de información cuenta
              con nueve (9) aplicaciones básicas y que son de utilidad para
              nuestros clientes, ya que con estas se garantiza la prestación de
              servicio en salud de una manera rápida, eficiente confiable y
              segura.
            </p>
          </div>
          <div
            className="servicio-item"
            style={{ backgroundColor: "#003366", color: "#ffffff" }}
          >
            <h3 style={{ color: "#dabf5c" }}>Facturación electrónica</h3>
            <p>
              Las facturas electrónicas es el soporte de transacciones de venta
              de bienes y servicios, en un sistema computacional que cumplen con
              las condiciones de expedición, recibo, rechazo y conservación, de
              acuerdo con la dirección de impuestos y aduanas nacionales de
              Colombia (DIAN).
            </p>
          </div>
          <div
            className="servicio-item"
            style={{ backgroundColor: "#003366", color: "#ffffff" }}
          >
            <h3 style={{ color: "#dabf5c" }}>Auditoria en calidad en salud</h3>
            <p>
              Contestación de glosas, procesos de devoluciones de facturas,
              procesos de liquidaciones contractuales con las EPS y asistencia a
              los procesos de contratación con las EPS, procesos de
              pre-auditoria, alistamiento y radicación de cuentas medicas
              auditoria de calidad
            </p>
          </div>
          <div
            className="servicio-item"
            style={{ backgroundColor: "#003366", color: "#ffffff" }}
          >
            <h3 style={{ color: "#dabf5c" }}>Capacitaciones</h3>
            <p>
              Rocky brinda procesos de capacitación y entrenamiento al personal
              de casa IPS sobre el manejo y diligenciamiento del software
              sistema de información en atención primaria con todos sus
              aplicativos, Contamos con un enlace y correo electrónico para que
              el personal de la IPS solicite las capacitaciones y entrenamiento
              según necesidad del servicio.
            </p>
          </div>
          <div
            className="servicio-item"
            style={{ backgroundColor: "#003366", color: "#ffffff" }}
          >
            <h3 style={{ color: "#dabf5c" }}>Soporte técnico</h3>
            <p>
              Soporte técnico del software sistema de información en atención
              primaria
            </p>
          </div>
          <div
            className="servicio-item"
            style={{ backgroundColor: "#003366", color: "#ffffff" }}
          >
            <h3 style={{ color: "#dabf5c" }}>
              Informes para entes de control (EPS)
            </h3>
            <p>
              Generación, validación y cargue de informes a los entes de control
              en salud
            </p>
          </div>
          <div
            className="servicio-item"
            style={{ backgroundColor: "#003366", color: "#ffffff" }}
          >
            <h3 style={{ color: "#dabf5c" }}>Suministro de computadores</h3>
            <p>
              Soluciones tecnológicas e implementaciones para IPS, alquiler y
              venta de equipos, soporte de hardware y software, servidores, etc
            </p>
          </div>
          <div
            className="servicio-item"
            style={{ backgroundColor: "#003366", color: "#ffffff" }}
          >
            <h3 style={{ color: "#dabf5c" }}>Instalación de redes</h3>
            <p>
              écnicas profesionales en instalación y mantenimiento de cableado
              estructurado en redes de computo.
            </p>
          </div>
        </div>
        <ClientesCarousel />
        {/* "Noticias" Section */}
        <motion.div
          id="noticias"
          className="noticias-section"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.1 }}
          transition={{ duration: 1, ease: "easeOut" }}
          style={{ opacity: 1 }}
        >
          <h2
            style={{
              fontFamily: "Righteous, sans-serif",
              fontSize: "5em",
              background: "( #003366)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              color: "transparent",
            }}
          >
            Noticias
          </h2>

          <div
            className="servicios-grid"
            style={{
              display: "flex",
              justifyContent: "space-around",
              flexWrap: "wrap",
              gap: "20px",
            }}
          >
            {/* Noticia 1 */}
            {arrayAllNews.map((newsItem, index) => (
              <div
                key={index}   // 👈 clave única
                className="noticias-item"
                style={{
                  backgroundColor: "#ffffff",
                  color: "#000000",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                  width: "400px",
                  height: "400px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  textAlign: "center",
                }}
              >
                <div>
                  <div className="d-flex justify-center">
                    <img
                      src={newsItem.image}
                      alt="Cajacopi Logo"
                      style={{
                        width: "100%",
                        maxWidth: "120px",
                        height: "auto",
                        borderRadius: "8px",
                        marginBottom: "15px",
                        objectFit: "contain",
                      }}
                    />
                  </div>
                  <h3 style={{ color: "#003366", marginBottom: "10px" }}>
                    {truncateText(
                      newsItem?.title,
                      45
                    )}
                  </h3>
                  <p style={{ fontSize: "14px", marginBottom: "15px" }}>
                    {truncateText(
                      newsItem?.content,
                      260
                    )}
                  </p>
                </div>
                <a
                  href={newsItem.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "inline-block",
                    backgroundColor: "#dabf5c",
                    color: "#003366",
                    padding: "10px 15px",
                    borderRadius: "5px",
                    textDecoration: "none",
                    fontWeight: "bold",
                  }}
                >
                  Ver más
                </a>
              </div>
            ))}
          </div>
        </motion.div>
        {/* "Herramientas" Section */}
        <motion.div
          id="herramientas"
          className="noticias-section"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.1 }}
          transition={{ duration: 1, ease: "easeOut" }}
          style={{ opacity: 1 }}
        >
          <h2
            style={{
              fontFamily: "Righteous, sans-serif",
              fontSize: "5em",
              background: "( #003366)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              color: "transparent",
            }}
          >
            Herramientas
          </h2>

          <div
            className="noticias-grid"
            style={{
              display: "flex",
              justifyContent: "space-around",
              flexWrap: "wrap",
              gap: "20px",
            }}
          >
            {/* Herramienta 1 */}
            <div
              className="noticias-item"
              style={{
                backgroundColor: "#ffffff",
                color: "#000000",
                padding: "20px",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                width: "400px",
                height: "400px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                textAlign: "center",
              }}
            >
              <div>
                <div className="d-flex justify-content-center">
                  <img
                    src={logrust}
                    alt="RustDesk.img"
                    style={{
                      width: "50%",
                      borderRadius: "8px",
                      marginBottom: "15px",
                    }}
                  /></div>
                <h3 style={{ color: "#003366", marginBottom: "10px" }}>
                  Anyviewer
                </h3>
                <p style={{ fontSize: "14px", marginBottom: "15px" }}>
                  Para brindarle soporte, por favor descargue e instale la nueva
                  aplicación de acceso remoto. Haga clic en el botón para
                  obtenerla desde el enlace disponible.
                </p>
              </div>
              <a
                href="https://drive.google.com/file/d/1nqj23rhElw2ozq03vQ9GCJbJiHMPG7VD/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-block",
                  backgroundColor: "#dabf5c",
                  color: "#003366",
                  padding: "10px 15px",
                  borderRadius: "5px",
                  textDecoration: "none",
                  fontWeight: "bold",
                }}
              >
                Descargar
              </a>
            </div>

            {/* Herramienta 2 */}
            <div
              className="noticias-item"
              style={{
                backgroundColor: "#ffffff",
                color: "#000000",
                padding: "20px",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                width: "400px",
                height: "400px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                textAlign: "center",
              }}
            >
              <div>
                <div className="d-flex justify-content-center">
                  <img
                    src={logBullzip}
                    alt="Bullzip.img"
                    style={{
                      width: "80%",
                      borderRadius: "8px",
                      marginBottom: "15px",
                    }}
                  />
                </div>

                <h3 style={{ color: "#003366", marginBottom: "10px" }}>
                  Bullzip
                </h3>
                <p style={{ fontSize: "14px", marginBottom: "15px" }}>
                  Haga clic en el botón para obtenerla desde el enlace disponible.
                </p>
              </div>
              <a
                href="https://drive.google.com/file/d/1II3FD80S3k5rdMeqTAHlNExZJve2so_B/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-block",
                  backgroundColor: "#dabf5c",
                  color: "#003366",
                  padding: "10px 15px",
                  borderRadius: "5px",
                  textDecoration: "none",
                  fontWeight: "bold",
                }}
              >
                Descargar
              </a>
            </div>

            {/* Herramienta 3 */}
            <div
              className="noticias-item"
              style={{
                backgroundColor: "#ffffff",
                color: "#000000",
                padding: "20px",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                width: "400px",
                height: "400px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                textAlign: "center",
              }}
            >
              <div>
                <div className="d-flex justify-content-center">
                  <img
                    src={logoApp}
                    alt="logoApp.img"
                    style={{
                      width: "45%",
                      borderRadius: "8px",
                      marginBottom: "15px",
                    }}
                  />
                </div>

                <h3 style={{ color: "#003366", marginBottom: "10px" }}>
                  App Rocky
                </h3>
                <p style={{ fontSize: "14px", marginBottom: "15px" }}>
                  Haga clic en el botón para obtenerla desde el enlace disponible.
                </p>
              </div>
              <a
                href="https://drive.google.com/file/d/1In8zaCPlrRVm3cPA7HJtWd-qtRcZ4UDq/view?usp=sharing"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: "inline-block",
                  backgroundColor: "#dabf5c",
                  color: "#003366",
                  padding: "10px 15px",
                  borderRadius: "5px",
                  textDecoration: "none",
                  fontWeight: "bold",
                }}
              >
                Descargar
              </a>
            </div>
          </div>
        </motion.div>
      </motion.div>

      <Footer />

      <ToastContainer />
      <style>{`
       


      `}</style>
    </>
  );
};
